import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { RadioButtons } from '../../Forms/RadioButtons'
import { RadioButtonsInputProps } from '../types'
import { useDefaultValue } from '../useDefaultValue'
import { useValidationState } from '../useValidationState'
import { getValidationRules } from '../validation'

export type RHFRadioButtonsProps = {
  input: RadioButtonsInputProps
  readonly?: boolean
  id?: string
}

export const RHFRadioButtons = ({ input, id }: RHFRadioButtonsProps) => {
  const { register } = useFormContext()

  const validationRules = useMemo(() => getValidationRules(input), [input])

  const validationState = useValidationState(input.slug)

  useDefaultValue({
    name: input.slug,
    value: input.defaultValue,
  })

  const options = useMemo(
    () =>
      input.options.map(option => ({
        ...register(input.slug, {
          ...validationRules,
        }),
        label: option.label,
        value: option.value,
      })),
    [input.options, input.slug, register, validationRules]
  )

  return (
    <RadioButtons
      id={id}
      {...input}
      name={input.slug}
      options={options}
      required={!!validationRules?.required}
      validation={validationState}
    />
  )
}
